import { betSlipActions } from "../constants/betslip.constants";

export const nativeUiConfig = {
  GB: {
    showNavBar: true,
    screenPercentage: {
      [betSlipActions.LOGIN]: 66.6,
      [betSlipActions.REGISTER]: 90,
    },
    dismissible: false,
    isFullScreen: false,
    showTitle: false,
  },
  ES: {
    showNavBar: true,
    screenPercentage: {
      [betSlipActions.LOGIN]: 66.6,
      [betSlipActions.REGISTER]: 90,
    },
    dismissible: false,
    isFullScreen: false,
    showTitle: true,
  },
  IT: {
    showNavBar: true,
    screenPercentage: {
      [betSlipActions.LOGIN]: 66.6,
      [betSlipActions.REGISTER]: 90,
    },
    dismissible: false,
    isFullScreen: false,
    showTitle: true,
  },
  DE: {
    showNavBar: true,
    screenPercentage: {
      [betSlipActions.LOGIN]: 66.6,
      [betSlipActions.REGISTER]: 90,
    },
    dismissible: true,
    isFullScreen: false,
    showTitle: true,
  },
  DEFAULT: {
    showNavBar: true,
    screenPercentage: {
      [betSlipActions.LOGIN]: 66.6,
      [betSlipActions.REGISTER]: 90,
    },
    dismissible: false,
    isFullScreen: false,
    showTitle: true,
  },
};
